// extracted by mini-css-extract-plugin
export default {"contentDetailReactions":"WmxLf","reactionsButton":"PxzBi"};